/* eslint-disable no-shadow */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-plusplus */
import { Row, Col } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import i18n from '../../i18n';
import BannerOverlay from './bannerOverlay/BannerOverlay';
import FlipAnimation from '../flipAnimation/FlipAnimation';
import './mainBanner.css';

// Return Defined
const MainBanner = () => {
  const [isBlur, setIsBlur] = useState(false);
  const [lang, setLang] = useState('en');

  function setIsBlurTrue() {
    setIsBlur(true);
  }

  function setIsBlurFalse() {
    setIsBlur(false);
  }

  function handleLang(lang) {
    setLang(lang);
    i18n.changeLanguage(lang).then(() => {
      i18n.options.lng = lang;
    });
  }

  useEffect(() => {
    const iconContainer = document.getElementsByClassName('iconContainer');
    if (isBlur === true) {
      // const iconContainer = document.getElementsByClassName('iconContainer');
      for (let i = 0; i < iconContainer.length; i++) {
        iconContainer[i].classList.add('isBlurredAdded');
      }
    } else {
      // const iconContainer = document.getElementsByClassName('iconContainer');
      for (let i = 0; i < iconContainer.length; i++) {
        iconContainer[i].classList.remove('isBlurredAdded');
      }
    }
  }, [isBlur]);

  useEffect(() => {}, [lang]);

  return (
    <section className="bannerComponent__SuperContainer">
      <BannerOverlay />
      <Row className="bannerComponent__subContainer">
        <Col md={10} lg={9}>
          <div className="bannerComponent__textContainer">
            <div className="home">
              <h1 dir="auto" id="resizing-h3" className="">
                Check your
                <FlipAnimation />
              </h1>
              <h1>right now</h1>
            </div>
            <p className="bannerComponent__textContainer-para">
              {i18n.t('heading')} Our HealthCheck tool uses your phone or laptop
              camera to measure your health in just 60 seconds.
            </p>
            <button
              className="bannerComponent__textContainer-button"
              type="button"
              onClick={() => handleLang('en')}
            >
              English
            </button>
            <button
              className="bannerComponent__textContainer-button"
              type="button"
              onClick={() => handleLang('fr')}
            >
              French
            </button>
            <button
              className="bannerComponent__textContainer-button"
              type="button"
              onMouseEnter={() => setIsBlurTrue()}
              onMouseLeave={() => setIsBlurFalse()}
            >
              LET’S START
            </button>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default MainBanner;
